import apiService from '@/services/apiService'

function normalizeFormat(raw = {}) {
  return {
    formato_id: raw.formato_id,
    codigo: raw.codigo || '',
    nombre: raw.nombre || '',
    prefijo: raw.prefijo || '',
    longitud_total: Number(raw.longitud_total || 13),
    pos_codigo_inicio: Number(raw.pos_codigo_inicio || 2),
    pos_codigo_longitud: Number(raw.pos_codigo_longitud || 5),
    pos_peso_inicio: Number(raw.pos_peso_inicio || 7),
    pos_peso_longitud: Number(raw.pos_peso_longitud || 5),
    unidad_peso: raw.unidad_peso || 'GRAMOS',
    activo: raw.activo !== false,
    borrado_logico: !!raw.borrado_logico
  }
}

export default {
  async list(includeDeleted = false) {
    const { data } = await apiService.get('/api/inventory/scale-formats', { include_deleted: includeDeleted })
    return Array.isArray(data?.data) ? data.data.map(normalizeFormat) : []
  },
  async create(payload) {
    const { data } = await apiService.post('/api/inventory/scale-formats', payload)
    return normalizeFormat(data?.data || {})
  },
  async update(formatoId, payload) {
    const { data } = await apiService.put(`/api/inventory/scale-formats/${formatoId}`, payload)
    return normalizeFormat(data?.data || {})
  },
  async remove(formatoId) {
    const { data } = await apiService.delete(`/api/inventory/scale-formats/${formatoId}`)
    return normalizeFormat(data?.data || {})
  }
}
